// Header ink: samples what sits behind the header bar at three x-positions and
// flips it to the light treatment over dark ground. A [data-header-ink] ancestor
// short-circuits the sampling with an explicit answer.
import { onReady } from '../utils/ready.js';

export function initHeaderInk() {
  function init() {
    var hdr = document.querySelector('.header');
    var bar = hdr && hdr.querySelector('.header__bar');
    if (!bar) return;
    function px(s) {
      var m = /rgba?\(([^)]+)\)/.exec(s || '');
      if (!m) return null;
      var p = m[1].split(/[\s,\/]+/).filter(Boolean).map(Number);
      return p.length < 3 ? null : [p[0], p[1], p[2], p.length > 3 ? p[3] : 1];
    }
    function chan(v) {
      v /= 255;
      return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    }
    function groundAt(x, y) {
      var els = document.elementsFromPoint(x, y);
      var r = 0, g = 0, b = 0, a = 0, i, el, o, c, w;
      for (i = 0; i < els.length && a < 0.995; i++) {
        el = els[i];
        if (hdr.contains(el)) continue;
        o = el.closest && el.closest('[data-header-ink]');
        if (o) return o.getAttribute('data-header-ink') === 'light' ? 0 : 1;
        c = px(getComputedStyle(el).backgroundColor);
        if (!c || c[3] < 0.01) continue;
        w = (1 - a) * c[3];
        r += c[0] * w;
        g += c[1] * w;
        b += c[2] * w;
        a += w;
      }
      if (a < 0.995) {
        var f = px(getComputedStyle(document.body).backgroundColor) || [255, 255, 255, 1];
        var wf = 1 - a;
        r += f[0] * wf;
        g += f[1] * wf;
        b += f[2] * wf;
      }
      return 0.2126 * chan(r) + 0.7152 * chan(g) + 0.0722 * chan(b);
    }
    var pending = 0, timer = 0;
    function run() {
      pending = 0;
      if (timer) {
        clearTimeout(timer);
        timer = 0;
      }
      var br = bar.getBoundingClientRect();
      if (br.bottom <= 0 || br.top >= (window.innerHeight || 0)) return;
      var y = (br.top + br.bottom) / 2;
      var v = [groundAt(innerWidth * 0.08, y), groundAt(innerWidth * 0.5, y), groundAt(innerWidth * 0.92, y)].sort(function (p, q) {
        return p - q;
      });
      hdr.classList.toggle('is-on-dark', v[1] < 0.5);
    }
    function schedule() {
      if (pending) return;
      pending = 1;
      requestAnimationFrame(run);
      timer = setTimeout(run, 250);
    }
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule);
    addEventListener('load', schedule);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
    run();
  }

  onReady(init);
}
